var rtlMapping = {
  left: 'right',
  right: 'left'
};
export function getBasePlacement(placement, rtl) {
  var basePlacement = (placement || '').split('-', 1).pop();
  return rtl && rtlMapping[basePlacement] || basePlacement;
}
//# sourceMappingURL=getBasePlacement.js.map
